import HttpRequest from "@/libs/axios";
import config from "@/config";
const baseUrl = config.baseUrl[config.appEnv];
const fileServerUrl = config.fileServerUrl[config.appEnv];

const axios = new HttpRequest(baseUrl, fileServerUrl);
export default axios;



// WEBPACK FOOTER //
// ./src/libs/api.request.js